import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventResultDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';


const { createEventResult } = EventsApiService();

export const useCreateEventResult = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: EventResultDTO) => {
            return createEventResult(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("result code has been created successfully!!");
            },
        },
    );
};
